import { NonEmptyArray } from 'fp-ts/NonEmptyArray';
import { ConfigureProductFormStep } from './formEnums';

export const configureProductSteps: NonEmptyArray<ConfigureProductFormStep> = [
    ConfigureProductFormStep.Details,
    ConfigureProductFormStep.Taxes,
    ConfigureProductFormStep.Pricing,
    ConfigureProductFormStep.Accounting,
    ConfigureProductFormStep.Services,
];
